// extracted by mini-css-extract-plugin
export default {"dialog":"LXl8HtxIgwJIyKAi","subHeader":"rv1SvFLzOjUeXH5x"};